module.exports = __webpack_public_path__ + "media/images/pc/stores/yokohama_ekimae/yokohama_ekimae_concept_01-6dcfadb7e43a5bb112daf3549d3a840c.jpg";